<template>
	<el-drawer title="会话留言记录" :visible.sync="show" :modal-append-to-body="false" size="1000px" :destroy-on-close="true" :wrapperClosable="false" :before-close="closeBox">
		<el-container class="leave-message-details" v-if="show">
			  <el-aside width="300px" class="aside">
				  <el-descriptions  :column="1">
				    <el-descriptions-item label="创建时间">{{$dayjs(source.createTime).format("YYYY-MM-DD :HH:mm")}}</el-descriptions-item>
				    <el-descriptions-item label="访客">{{source.name || '暂无'}}</el-descriptions-item>
				    <el-descriptions-item label="品牌">{{source.brandName || '暂无'}}</el-descriptions-item>
				    <el-descriptions-item label="邮箱">{{source.email || '暂无'}}</el-descriptions-item>
					<el-descriptions-item label="渠道">{{getChannel(source.channel)}}</el-descriptions-item>
					<el-descriptions-item label="操作人">{{source.dealName || '暂无'}}</el-descriptions-item>
					<el-descriptions-item label="技能组">{{source.skillGroupName || '暂无'}}</el-descriptions-item>
					<el-descriptions-item label="留言状态">
						 <el-link :underline="false" :type="getStatus(source.status,'type')">{{getStatus(source.status,'name')}}</el-link>
					</el-descriptions-item>
					<el-descriptions-item label="操作">
						<el-button type="info" plain size="mini" :disabled="isDisabled" @click="toDiscard">废弃</el-button>
					</el-descriptions-item>
				  </el-descriptions>
			  </el-aside>
			  <el-container>
			     <el-main>
					 <history-list ref="historyList" :apiUrl="apiUrl" type="leveMsg" :sessionId="source.session"  senderType="senderType"></history-list>
				 </el-main>
			     <el-footer height="500px" v-if="isEditorShow">
					 <Editor :row_source="source" v-on="$listeners" @loadHistory="loadHistory"/>
				 </el-footer>
			   </el-container>
		</el-container>
	</el-drawer>
</template>

<script>
	import { mapState } from 'vuex'
	import {leave_msg_status,channel} from '../../data.js';
	import Editor from './editor';
	export default {
		components:{
			Editor
		},
		model:{
			prop:'show',
			event:'close'
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			source:{
				default:''
			}
		},
		computed:{
			...mapState({
				userId:state => state.user.userInfo.userId
			}),
			isDisabled(){
				if(this.source.status == 3) return true;
				if(!this.source.dealId) return false;
				return this.source.dealId != this.userId
			},
			isEditorShow(){
				if(this.source.status == 3 || this.source.status == -2) return false;
				if(this.source.status == 2) return this.source.dealId == this.userId;
				return true
			}
		},
		watch:{
			show(value){
				if(value){
					this.apiUrl = `livechat/leavemsg/get/detail/${this.source.user}`
				}
			}
		},
		data(){
			return {
				dialogVisible:true,
				apiUrl:''//
				
			}
		},
		methods:{
			loadHistory(user){
				this.$refs.historyList.onLoadData(`livechat/leavemsg/get/detail/${user}`);
			},
			toDiscard(){
				let that = this;
				this.$confirm("废弃留言后无法向用户回复消息，是否确认废弃。", "确认要废弃该条留言吗？", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "error",
						center: true,
						customClass: "confirm-element-model"
					}).then(() => {
							that.$api.deleteImLeaveMessageListsItem({
								user:that.source.user,
								session:that.source.session
							}).then(res => {
								if(res.errcode != 0) return;
								that.$notify.success("留言废弃成功");
								that.$emit('confirm',this.source.session)
							})
					}).catch(() => {
					
					});
			},
			closeBox(){
				this.$emit('close',false)
			},
			getChannel(key){
				let index = channel.findIndex(el => el.id == key);
				if(index != -1) return channel[index].name;
				return '暂无'
			},
			getStatus(status,key){
				let result = leave_msg_status.filter(el => el.id == status);
				if(result.length > 0) return result[0][key]
				return ''
			},
		}
	}
</script>

<style lang="scss" scoped>
	.leave-message-details {
		height: 100%;
		::v-deep {
			.el-aside {
				background: #eef1f6;
				padding: 8px 24px;
				border-radius: 2px;
				display: block;
				line-height: 32px;
				font-size: 16px;
				color: #2c3e50;
				margin-bottom: 0;
			}
			.el-descriptions {
				padding: 20px 0;
			}
			.el-descriptions__body {
				background: none;
			}
			.el-descriptions-item__cell {
				padding-bottom: 20px;
			}
		}
	}
</style>
